import React, { ReactNode, useState } from 'react';
import { Link, NavLink, useRouteMatch, useHistory } from 'react-router-dom';
import { ReactComponent as GameClubLogo } from '@ui-kit/images/gameColonyLogo.svg';
import { ReactComponent as GameClubUSA } from '@ui-kit/images/gameClubUSA.svg';
import { t } from '@base/utils/helpers';
import Burger from './burger';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { User } from './user';
import { HeaderTickets } from '@base/features/tickets/components/headerTickets';
import { Invites } from '../../features/invites/components/invites';
import { ITicketService } from '@base/features/tickets/model/interfaces';
import { container } from 'tsyringe';
import classNames from 'classnames';
import styles from '../styles/header.module.scss';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import UserService from '@base/features/user/model/userService';

const links = {
  [MAIN_ROUTES.game]: 'game',
  [MAIN_ROUTES.lobby]: 'lobby',
  [MAIN_ROUTES.tournaments]: 'tournaments',
  [MAIN_ROUTES.ladder]: 'ladder',
  [MAIN_ROUTES.forum]: 'forum',
  [MAIN_ROUTES.help]: 'help',
};

function Header(props: { currentUser?: string; icon: ReactNode }) {
  const { currentUser } = props;
  const history = useHistory();
  const ticketsService: ITicketService = container.resolve('ticketsService');
  const [loading, setLoading] = useState(false);
  const gameRoute = useRouteMatch(MAIN_ROUTES.game);
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const userService: UserService = container.resolve('userService');
  const isActiveTable = playersOnlineRepository.me?.getTable() && !gameRoute;

  return (
    <header className={styles.header}>
      <Link to="#">{props.icon}</Link>

      {currentUser && (
        <nav>
          <ul>
            {Object.entries(links).map(([route, title]) => (
              <li key={route}>
                <NavLink
                  className={classNames(
                    isActiveTable && route === MAIN_ROUTES.game
                      ? [styles.link, styles.activeTable]
                      : styles.link
                  )}
                  activeClassName={styles.link_active}
                  to={route}
                >
                  {t(title)}
                </NavLink>
              </li>
            ))}
            <li>
              <NavLink
                className={styles.userInfo}
                activeClassName={styles.link_active}
                to={MAIN_ROUTES.userInfo}
              >
                <User user={currentUser} />
              </NavLink>
            </li>
            <li>
              <div
                onClick={async () => {
                  if (userService.isGuestPlayer())
                    return userService.openGuestModal(() => history.push(MAIN_ROUTES.register));
                  setLoading(true);
                  await ticketsService.openPaymentModal();
                  setLoading(false);
                }}
                className={classNames(styles.link, styles.tickets, {
                  [styles.tickets_loading]: loading,
                })}
              >
                {!loading && <HeaderTickets />}
              </div>
            </li>
          </ul>
        </nav>
      )}

      {!currentUser && (
        <a
          href={MAIN_ROUTES.gameColony}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.mainLogo}
        >
          <GameClubLogo />
          <GameClubUSA width={142} height={45} />
        </a>
      )}
      {currentUser && <Invites />}
      <Burger currentUser={currentUser} />
    </header>
  );
}

export default Header;
